import styled, { css } from 'styled-components';

export const DashboardItemOptionContainer = styled.div`
  display: flex;
  gap: var(--spacing-s);
`;

export const TitleContainer = styled.h5`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-s);
`;

export const InfoItemContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const DashboardsContainer = styled.div.attrs({
  className: 'dashboards',
})`
  width: 100%;
  height: 100vh;
  overflow: auto;
  margin-top: 0;

  ${(p) =>
    p.isDashboardView &&
    css`
      display: flex;
      flex-direction: row;

      > .dashboard {
        flex-grow: 1;
      }
    `}
`;
